import React from 'react';
import {ConfirmButton, ConfirmButtonProps} from '../../../components';
import {useRouteHistory} from '../../../hooks';

type SkipButtonProps = ConfirmButtonProps;

const SkipButton: React.FC<SkipButtonProps> = ({children, ...props}) => {
    const route = useRouteHistory(['close-account']);
    return (
        <ConfirmButton
            ConfirmDialogProps={{
                submitRedirectPath: route.from || '/overview',
                submit: 'epic.affiliate.settings.tax.profile.continue.creator.v2'
            }}
            {...props}>
            {children}
        </ConfirmButton>
    );
};

export default SkipButton;
